import type { JSX } from 'react'

import { AuthPopup } from "/app/libraries/arcana/src/blocks/Popup/Templates/index.ts"
import { PrimarySubmitButton } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"
import { TextBlock, TextBlockDirection } from "/app/libraries/arcana/src/blocks/TextBlock/index.ts"
import { TextBoxCaption3, TextBoxHeadline1 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { toArray } from '~/shared/helpers'
import { AuthLayout } from '~/widgets/auth'

interface Props {
  title: string
  body: string | string[]
  button: string
  to: string
}

FinalMessage.displayName = 'FinalMessage'
export function FinalMessage({ title, body, button, to }: Props): JSX.Element {
  return (
    <AuthLayout>
      <AuthPopup>
        <TextBoxHeadline1 title={title} />
        <TextBlock direction={TextBlockDirection.COLUMN}>
          {toArray(body).map((p, i) => (
            <TextBoxCaption3 key={i} title={p} />
          ))}
        </TextBlock>
        <a href={to}>
          <PrimarySubmitButton title={button} />
        </a>
      </AuthPopup>
    </AuthLayout>
  )
}
